<template>
  <lf-alert type="error" icon="x-circle">
    <div class="flex flex-row space-x-1">
      <span class="flex-none font-bold" data-cy="service-error-title">
        {{
          $t("DEALS.SERVICES.API_FAILED_TITLE", {
            action: getApiFailedActionName(haveResponse),
          })
        }}:
      </span>
      <span data-cy="service-error-message">
        {{ serviceErrorMessage }}
      </span>
    </div>
    <span
      v-if="haveResponse"
      class="block italic"
      data-cy="service-recent-message"
    >
      {{ $t("DEALS.SERVICES.API_RECENT_RESPONSE_SHOWN") }}
    </span>
  </lf-alert>
</template>

<script setup lang="ts">
import { getApiFailedActionName } from "@/helpers/services";

import LfAlert from "@/components/ui/LfAlert.vue";

defineProps({
  serviceErrorMessage: {
    type: String,
    default: "",
  },
  haveResponse: {
    type: Boolean,
    default: false,
  },
});
</script>
